var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91659 1.77087C1.83604 1.77087 1.77075 1.83617 1.77075 1.91671V4.25004C1.77075 4.33058 1.83604 4.39587 1.91659 4.39587H4.24992C4.33046 4.39587 4.39575 4.33058 4.39575 4.25004V1.91671C4.39575 1.83617 4.33046 1.77087 4.24992 1.77087H1.91659ZM0.895752 1.91671C0.895752 1.35292 1.35279 0.895874 1.91659 0.895874H4.24992C4.81371 0.895874 5.27075 1.35292 5.27075 1.91671V4.25004C5.27075 4.81383 4.81371 5.27087 4.24992 5.27087H1.91659C1.35279 5.27087 0.895752 4.81383 0.895752 4.25004V1.91671Z",
    fill: "#A0AEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74992 1.77087C7.66938 1.77087 7.60409 1.83617 7.60409 1.91671V4.25004C7.60409 4.33058 7.66938 4.39587 7.74992 4.39587H10.0833C10.1638 4.39587 10.2291 4.33058 10.2291 4.25004V1.91671C10.2291 1.83617 10.1638 1.77087 10.0833 1.77087H7.74992ZM6.72909 1.91671C6.72909 1.35292 7.18613 0.895874 7.74992 0.895874H10.0833C10.647 0.895874 11.1041 1.35292 11.1041 1.91671V4.25004C11.1041 4.81383 10.647 5.27087 10.0833 5.27087H7.74992C7.18613 5.27087 6.72909 4.81383 6.72909 4.25004V1.91671Z",
    fill: "#A0AEC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91659 7.60421C1.83604 7.60421 1.77075 7.6695 1.77075 7.75004V10.0834C1.77075 10.1639 1.83604 10.2292 1.91659 10.2292H4.24992C4.33046 10.2292 4.39575 10.1639 4.39575 10.0834V7.75004C4.39575 7.6695 4.33046 7.60421 4.24992 7.60421H1.91659ZM0.895752 7.75004C0.895752 7.18625 1.35279 6.72921 1.91659 6.72921H4.24992C4.81371 6.72921 5.27075 7.18625 5.27075 7.75004V10.0834C5.27075 10.6472 4.81371 11.1042 4.24992 11.1042H1.91659C1.35279 11.1042 0.895752 10.6472 0.895752 10.0834V7.75004Z",
    fill: "#A0AEC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74992 7.60421C7.66938 7.60421 7.60409 7.6695 7.60409 7.75004V10.0834C7.60409 10.1639 7.66938 10.2292 7.74992 10.2292H10.0833C10.1638 10.2292 10.2291 10.1639 10.2291 10.0834V7.75004C10.2291 7.6695 10.1638 7.60421 10.0833 7.60421H7.74992ZM6.72909 7.75004C6.72909 7.18625 7.18613 6.72921 7.74992 6.72921H10.0833C10.647 6.72921 11.1041 7.18625 11.1041 7.75004V10.0834C11.1041 10.6472 10.647 11.1042 10.0833 11.1042H7.74992C7.18613 11.1042 6.72909 10.6472 6.72909 10.0834V7.75004Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGed);
export default __webpack_public_path__ + "static/media/ged.72414848c3513f3fab3058292221d392.svg";
export { ForwardRef as ReactComponent };